<script setup lang="ts">
import { watchEffect } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useContentStore } from '@/stores/content'
import { applyPageMetadata } from '@/utils/pageMetadata'
import { resolvePageMetadata } from '@/utils/socialMetadata'
import { LEGAL_PAGE_METADATA } from '@/config/legal'

const route = useRoute()
const content = useContentStore()

watchEffect(() => {
  const slug = String(route.params.slug || '')
  const kind = String(route.name || '')
  const entity = kind === 'article-detail' ? content.articles.find((item) => item.slug === slug)
    : kind === 'service-detail' ? content.services.find((item) => item.slug === slug)
      : kind === 'specialty-detail' ? content.specialties.find((item) => item.slug === slug)
        : kind === 'doctor-detail' ? content.doctors.find((item) => item.slug === slug) : undefined
  const isArticle = entity && 'title' in entity
  const legalMetadata = LEGAL_PAGE_METADATA[kind]
  const title = entity ? (isArticle ? entity.title : entity.name) : ({
    home: content.settings.seoTitle, services: 'Servicios medicos', specialties: 'Especialidades medicas',
    doctors: 'Especialistas', articles: 'Articulos', appointment: 'Agendar cita', contact: 'Contacto',
    'doctor-interest': 'Soy doctor',
  } as Record<string, string>)[kind]
  const resolvedTitle = legalMetadata?.title || title
  const description = legalMetadata?.description || (entity ? (isArticle ? entity.summary : 'shortDescription' in entity ? entity.shortDescription : 'bio' in entity ? entity.bio : '') : content.settings.seoDescription)
  const imageUrl = (entity ? (isArticle ? entity.featuredImageUrl : 'photoUrl' in entity ? entity.photoUrl : entity.imageUrl) : '') || content.settings.defaultSocialImage || '/social/cendoscar-default-share-1200x630.jpg'
  applyPageMetadata(resolvePageMetadata({
    path: route.path, socialMetadata: entity?.socialMetadata || (!entity && kind === 'home' ? content.settings.socialMetadata : undefined),
    title: resolvedTitle, description, imageUrl, type: isArticle ? 'article' : kind === 'doctor-detail' ? 'profile' : 'website',
    noIndex: route.path.startsWith('/admin') || kind === 'appointment',
  }))
})
</script>

<template><RouterView /></template>
